export class BackendError extends Error {
  constructor(
    message: string,
    public code: string,
    public statusCode: number = 500,
  ) {
    super(message);
    this.name = 'BackendError';
  }
}

export class AuthError extends BackendError {
  constructor(message: string) {
    super(message, 'AUTH_ERROR', 401);
    this.name = 'AuthError';
  }
}

export class NotFoundError extends BackendError {
  constructor(message: string) {
    super(message, 'NOT_FOUND', 404);
    this.name = 'NotFoundError';
  }
}

export class ValidationError extends BackendError {
  constructor(message: string) {
    super(message, 'VALIDATION_ERROR', 400);
    this.name = 'ValidationError';
  }
}

export class DatabaseError extends BackendError {
  constructor(message: string) {
    super(message, 'DATABASE_ERROR', 500);
    this.name = 'DatabaseError';
  }
}

const AUTH_ERROR_CODES = new Set(['PGRST301', 'PGRST302']);

type SupabaseLikeError = {
  code?: string;
  message?: string;
};

export function isAuthRelated(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const candidate = error as SupabaseLikeError;
  if (candidate.code && AUTH_ERROR_CODES.has(candidate.code)) return true;
  const message = String(candidate.message ?? '').toLowerCase();
  return message.includes('jwt') || message.includes('401') || message.includes('403');
}

export function handleSupabaseError(error: SupabaseLikeError): never {
  if (isAuthRelated(error)) {
    throw new AuthError(error.message || '認証エラーが発生しました');
  }
  if (error.code === 'PGRST116') {
    throw new NotFoundError('リソースが見つかりません');
  }
  if (error.code === '23505') {
    throw new ValidationError('データが既に存在します');
  }
  if (error.code === '23503') {
    throw new ValidationError('参照整合性制約違反です');
  }
  throw new DatabaseError(error.message || '不明なデータベースエラー');
}
